import { Component, OnDestroy, OnInit, computed, inject } from '@angular/core';
import frenchi18n from '@assets/i18n/fr.json';
import { WaitOnWebauthNotification } from '@core/usecase/waitOnWebauthNotification';
import { TranslateModule } from '@ngx-translate/core';
import { ProcessEventService } from '@shared/services/process-event.service';
import { StoreService } from '@shared/services/store.service';
import { TrackerService } from '@shared/services/tracker.service';
import { GetAccounts } from '@core/usecase/getAccounts';
import { WaitOnExternalBankLoginVM } from './wait-on-external-bank-login.viewmodel';

@Component({
  selector: 'app-wait-on-external-bank-login',
  templateUrl: './wait-on-external-bank-login.component.html',
  standalone: true,
  imports: [TranslateModule],
})
export class WaitOnExternalBankLoginComponent implements OnInit, OnDestroy {
  private readonly storeService = inject(StoreService);
  private readonly processPageParams = this.storeService.select('PROCESS_PAGE_PARAMS');
  readonly regionalBankName = computed(() => this.processPageParams()?.regionalBankName);
  readonly selectedBank = this.storeService.selectOrThrow('SELECTED_BANK');
  private waitOnExternalBankLoginVM: WaitOnExternalBankLoginVM;

  constructor(
    private processEventService: ProcessEventService,
    private waitOnWebauthNotification: WaitOnWebauthNotification,
    private tracker: TrackerService,
    private getAccounts: GetAccounts
  ) {
    this.waitOnExternalBankLoginVM = new WaitOnExternalBankLoginVM(
      this.processEventService,
      this.storeService,
      this.waitOnWebauthNotification,
      this.getAccounts
    );
  }

  async ngOnInit() {
    this.tracker.trackPage({ taggingPage: 'WAIT_ON_EXTERNAL_BANK_LOGIN' });
    await this.waitOnExternalBankLoginVM.onInit();
  }

  ngOnDestroy(): void {
    this.waitOnExternalBankLoginVM.stopPolling();
  }

  backToBankChoice(): void {
    this.tracker.trackClick({
      click: frenchi18n.choose_another_bank,
      taggingPage: 'WAIT_ON_EXTERNAL_BANK_LOGIN',
    });

    this.waitOnExternalBankLoginVM.backToBankChoice();
  }
}
